<template>
  <div class="">
    <div class="form-group">
      <label class="form-label">Titel</label>
      <input type="text" name="Titel" class="input w-full" v-model="deadline.title" v-bind:class="{ 'input-error': errors.title }"/>
      <div class="input-error-message" v-if="errors.title">{{ errors.title[0] }}</div>
    </div>
    <div class="flex">
      <div class="form-group">
        <label class="form-label"></label>
        <date-picker v-model="deadline.completion_date" valueType="format" format="DD.MM.YYYY"></date-picker>
        <div class="input-error-message" v-if="errors.completion_date">{{ errors.completion_date[0] }}</div>
      </div>
    </div>
    <div class="form-group">
      <p-radio class="p-icon p-round p-plain p-smooth" color="danger-o" v-model="deadline.is_important" :value="true">
        <i class="icon far fa-clock" slot="extra"></i>
        Frist
      </p-radio>
      <p-radio class="p-icon p-round p-plain p-smooth" color="info-o" v-model="deadline.is_important" :value="false">
        <i class="icon far fa-clock" slot="extra"></i>
        Wiedervorlage
      </p-radio>
      <div class="input-error-message" v-if="errors.is_important">{{ errors.is_important[0] }}</div>
    </div>
<!--    <div class="form-group">-->
<!--      <label class="form-label">Bearbeiter:in</label>-->
<!--      <v-select v-model="deadline.assignee_id"-->
<!--                :options="[{label: 'niemand', id: null},{label: 'Chef', id: 2}, {label: 'Horack', id: 53}]"-->
<!--                :reduce="o => o.id"-->

<!--      ></v-select>-->
<!--    </div>-->
    <div class="form-group">
      <textarea class="w-full input" v-model="deadline.description" rows="6">{{ deadline.description }}</textarea>
    </div>
    <div class="flex justify-end my-6">
      <button v-on:click="save" class="btn btn-primary">Speichern</button>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/de';
import moment from 'moment';

export default {
  components: {DatePicker},
  props: [
    'actionUrl',
    'method',
    'initialDeadline',
  ],
  data() {
    return {
      deadline: JSON.parse(JSON.stringify(this.initialDeadline)),
      errors: [],
    }
  },
  methods: {
    save: function () {
      this.$http[this.method](this.actionUrl, {deadline: this.deadline}).then(response => {
        console.log(response)
        Vue.$toast.success('Frist wurde gespeichert.')
        this.$emit('updated')
      }, response => {
        console.log(response)
        if (response.status = 422) {
          this.errors = response.body;
        }
      })
    },
  },

  mounted: function () {
    this.deadline.completion_date = moment(this.deadline.completion_date, "YYYY-MM-DD").format("DD.MM.YYYY");
  }
}
</script>
